import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MeRes } from '../services/api.types';

const LS_USER_INFO_KEY = 'userInfo';
const LSUserInfo = localStorage.getItem(LS_USER_INFO_KEY);

const initialState = LSUserInfo ? (JSON.parse(LSUserInfo) as MeRes) : null;

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<MeRes>) => {
      localStorage.setItem(LS_USER_INFO_KEY, JSON.stringify(action.payload));
      return { ...action.payload };
    },
    logout: () => {
      localStorage.removeItem(LS_USER_INFO_KEY);
      return null;
    },
  },
});

export const userActions = userSlice.actions;
export const userReducer = userSlice.reducer;
